<div class="container pb-4 pt-4 ps-0 ps-md-2 pe-0 pe-md-0">
  <app-breadcrumb currentRouteName="Ajout d'un utilisateur"
  [previousRoute]="{name: 'Gestion des utilisateurs', route: '/users'}"></app-breadcrumb>
  <div class="container col-md-8 bg-white mt-4 ps-2 ps-md-5 pe-2 pe-md-5 pb-4">
    <h1 class="pt-4 pb-2 pb-md-4" id="title">Demande d'ajout d'un utilisateur au Portail</h1>

    @if (!created) {
      <app-user-form (newUser)="createUser($event)"></app-user-form>
    }

    @if (created) {
      <div>
        <div class="alert alert-success ms-2 me-2 ms-md-5 me-md-5 d-flex align-items-center">
          <fa-icon icon="clock" size="2x" class="me-4 d-none d-md-block"></fa-icon>
          <div>
            <p class="mb-0">Votre demande d'ajout d'utilisateur a été transmise.</p>
            <p class="mb-0">Elle sera traitée dans les meilleurs délais.</p>
            <p class="mb-0">Vous pouvez retrouver l'historique de vos demandes <a routerLink="/utilisateurs/historique">ici</a>
          </p>
        </div>
      </div>
      <div class="d-flex justify-content-between ms-2 me-2 ms-md-5 me-md-5">
        <a routerLink="/utilisateurs">Retourner à la gestion des utilisateurs</a>
        <a class="d-none d-md-inline" routerLink="/">Retourner à l'accueil</a>
      </div>
    </div>
  }
</div>
</div>
